export default function () {
  return {
    banners: [],
    bannersCurrentPage: 1,
    bannersLastPage: 1,
    bannersPerPage: 0,
    bannersTotal: 0,
    bannersActiveTotal: 0,
    bannersLoading: false,
    indexPage: null
  }
}
